import * as React from 'react';
import { BrushedLabel } from '../../../atoms/layout/BrushedLabel';
import classNames from 'classnames';
import './courseExamList.module.scss';
import { Button } from '../../../../../commonv3/components/atoms/buttons/Button';
import { CourseExamShowView, ExamSectionIndexView } from '../../../../types/courseExams';
import { ExamSectionType } from '../../../../../commonv3/types/courseExams';
import CompleteLabelSvg from './images/check_24px_outlined.svg';
import ChevronRight from './images/chevron-right.svg';

export const CourseExamList = ({ children }) => (
    <div styleName="list-wrapper">
        <div styleName="list">
            <div styleName="list-header">
                <BrushedLabel>課題にチャレンジしよう</BrushedLabel>
            </div>
            <div styleName="list-body">{children}</div>
        </div>
    </div>
);

const SectionList = ({ children }) => <div styleName="section-list">{children}</div>;
const CompleteBadge = () => <img src={CompleteLabelSvg} styleName="complete-badge" />;
const SectionTypeLabel = ({ sectionType, completed }) => {
    switch (sectionType) {
        case ExamSectionType.WRITING:
            return <div styleName="section-type-label">{completed && <CompleteBadge />}筆記試験</div>;
        case ExamSectionType.PRACTICAL:
            return <div styleName="section-type-label">{completed && <CompleteBadge />}実技試験</div>;
    }
};
const SectionItem = ({ index, section, activated, onClick }) => (
    <div styleName={classNames('section-item', { activated: activated })} onClick={activated ? onClick : undefined}>
        <div styleName="section-title-wrapper">
            <div styleName="section-type-label-wrapper">
                <span styleName="section-index">{String(index + 1).padStart(2, '0')}.</span>
                <SectionTypeLabel sectionType={section.section_type} completed={section.completed} />
            </div>
            <div styleName="section-title">{section.title}</div>
        </div>
        <img src={ChevronRight} styleName="chevron-right" />
    </div>
);

type ListItemProps = {
    exam: CourseExamShowView;
    onStartClick: () => any;
    onSectionClick: (section: ExamSectionIndexView) => any;
};

export const CourseExamListItem = ({ exam, onStartClick, onSectionClick }: ListItemProps) => (
    <div styleName="list-item">
        <div styleName="list-item-header">
            <div>
                <div styleName="challenge-label">Challenge</div>
                <div styleName="title">{exam.title}</div>
            </div>
        </div>
        <SectionList>
            {exam.sections.map((section, index) => (
                <SectionItem
                    key={section.id}
                    index={index}
                    section={section}
                    activated={true}
                    onClick={() => onSectionClick(section)}
                />
            ))}
        </SectionList>
    </div>
);
